import { Injectable } from '@angular/core';
import { UserService } from '../../resources/auth/user.service';
import { AuthenticationService } from '../../resources/auth/authentication.service';
import { User } from '../../resources/models/user.model';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class LoginPageService {
  constructor(
    private authenticationService: AuthenticationService,
    private userService: UserService,
  ) {}

  public login(email: string, password: string) {
    return this.authenticationService.login(email, password);
  }

  public isLoggedIn(): Observable<boolean> {
    return this.userService.user.take(1).map((user: User) => {
      return !!user;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/login/login.page.service.ts